import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CompareProvider } from "./context/CompareContext";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import CompareBar from "./components/CompareBar";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import SearchPage from "./pages/SearchPage";
import PropertyDetailPage from "./pages/PropertyDetailPage";
import NeighbourhoodsPage from "./pages/NeighbourhoodsPage";
import NeighbourhoodDetailPage from "./pages/NeighbourhoodDetailPage";
import MortgageCalculatorPage from "./pages/MortgageCalculatorPage";
import ContactPage from "./pages/ContactPage";
import SellPage from "./pages/SellPage";
import NewBuildsPage from "./pages/NewBuildsPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import FavoritesPage from "./pages/FavoritesPage";
import SavedSearchesPage from "./pages/SavedSearchesPage";
import EmailPreferencesPage from "./pages/EmailPreferencesPage";
import TeamPage from "./pages/TeamPage";  // exports the "About Me" page component
import ComparePage from "./pages/ComparePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import LiveChatWidget from "./components/LiveChatWidget";

function App() {
  return (
    <AuthProvider>
      <CompareProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/property/:id" element={<PropertyDetailPage />} />
                <Route path="/neighbourhoods" element={<NeighbourhoodsPage />} />
                <Route path="/neighbourhoods/:id" element={<NeighbourhoodDetailPage />} />
                <Route path="/mortgage-calculator" element={<MortgageCalculatorPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/sell" element={<SellPage />} />
                <Route path="/new-builds" element={<NewBuildsPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/compare" element={<ComparePage />} />
                <Route path="/favorites" element={<FavoritesPage />} />
                <Route path="/saved-searches" element={<SavedSearchesPage />} />
                <Route path="/email-preferences" element={<EmailPreferencesPage />} />
                <Route path="/about" element={<TeamPage />} />
                <Route path="/team" element={<TeamPage />} />{/* legacy alias */}
                <Route path="/privacy" element={<PrivacyPolicyPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms" element={<TermsOfUsePage />} />
                <Route path="/terms-of-use" element={<TermsOfUsePage />} />
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </main>
            <CompareBar />
            <Footer />
            <LiveChatWidget />
          </div>
        </BrowserRouter>
      </CompareProvider>
    </AuthProvider>
  );
}

export default App;
